import React from 'react'
import { Avatar, useMantineColorScheme } from '@mantine/core'

type AgAvatarProps = {
  firstName: string
  lastName: string
  src?: string
  radius?: string
  color?: string
  size?: number
} & React.ComponentPropsWithoutRef<typeof Avatar>

export default function AgAvatar({
  firstName,
  lastName,
  src,
  size = 50,
  radius = 'xl',
  color = 'green',
  ...props
}: AgAvatarProps) {
  const { colorScheme } = useMantineColorScheme()
  const isDark = colorScheme === 'dark'

  const initials = firstName
    ? `${firstName[0].toUpperCase()}${lastName ? lastName[0].toUpperCase() : ''}`
    : null

  const background = isDark
    ? 'linear-gradient(135deg, rgba(0, 40, 0, 0.9) 0%, rgba(0, 60, 0, 0.8) 100%)'
    : 'linear-gradient(135deg, rgba(0, 120, 0, 0.1) 0%, rgba(0, 150, 0, 0.15) 100%)'
  const borderColor = isDark ? 'rgba(0, 255, 0, 0.5)' : 'rgba(0, 120, 0, 0.4)'
  const textColor = isDark ? '#00ff00' : '#007700'

  return (
    <Avatar
      src={src}
      size={size}
      radius={radius}
      color={color}
      styles={{
        root: {
          background,
          border: `2px solid ${borderColor}`,
        },
        placeholder: {
          color: textColor,
          fontWeight: 600,
          fontSize: size > 40 ? '1rem' : '0.75rem',
        },
      }}
      {...props}
    >
      {!src && initials}
    </Avatar>
  )
}
